import * as formatting from './formatting';
import { fetchA } from '@bb/session-manager';

/**
 * This class is meant to be a helpful frontend interface for the Generic
 * Mongo Data Router found in v2 of the bbwebapi.
 */
export class MongoFieldsAPI {
  // Root url to append to
  baseUrl = new URL('/api/v2/mongo/', window.location.origin).toString();
  // Name from the mongoose schema within bbwebapi API
  mongoSchemaName = '';
  // A URL friendly version of the schema name
  urlId = '';

  /**
   * Creates a new instance of MongoFieldsAPI
   * @param {string} mongodbSchemaName Name of Schema from mongoose.
   * @param {object} opts Various options
   * @param {object} opts.defaultHeaders headers to send with all requests
   */
  constructor(mongodbSchemaName) {
    this.mongoSchemaName = mongodbSchemaName;
    this.urlId = formatting.toUrlCase(mongodbSchemaName);
    this.baseUrl = new URL(`${this.urlId}/fields`, this.baseUrl).toString();
  }

  /**
   * Field fetching from the V2 API within bbwebapi
   *
   * @param {object} params Various params
   * @param {string[]} params.fields Fields to return.
   * @param {object} params.query Mongodb query to filter before getting unique values.
   * @param {string[]} params.unique_values_for Returns all the unique values within
   *   a specified fields
   * @returns object containing json response
   */
  async fetchFields(params = {}) {
    const qParams = formatting.serializeParams(params);
    const resp = await fetchA(`${this.baseUrl}?${qParams}`);
    return resp.json();
  }
}
